import { render, staticRenderFns } from "./telecomTemplate.vue?vue&type=template&id=2b7ce395&scoped=true"
import script from "./telecomTemplate.vue?vue&type=script&lang=js"
export * from "./telecomTemplate.vue?vue&type=script&lang=js"
import style0 from "./telecomTemplate.vue?vue&type=style&index=0&id=2b7ce395&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7ce395",
  null
  
)

export default component.exports